<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-center" :class="classes">
            <span>COPYRIGHT &copy;</span>
            <span>{{ new Date().getFullYear() }} </span> &nbsp;
            <a href="/" >FilledU </a>
            <span class="hidden sm:inline-block">, All rights Reserved </span>
            <a href="https://filledyou.com/pages/privacy" >  개인정보 처리 방침 </a>
            <feather-icon icon="MailIcon" svgClasses="stroke-current text-dark w-6 h-6" class="ml-2" type="flat" style="padding:10px;"/> <p class="sm:block hidden">admin@filledyou.com </p>

            <br>
          <div class="vx-row">
            <!-- <vs-button disabled color="dark" type="flat" icon-pack="feather" icon="icon-mail" style="padding:10px; margin-left:10px;"> admin@filledyou.com </vs-button> -->
            <vs-button onclick = "window.open('https://smtp.filledyou.com/professor_manual.pdf')" color="primary" type="flat" icon-pack="feather" icon="icon-book" style="padding:10px; margin-left:20px;"/> <p class="sm:inline-block hidden" style="margin-top:10px;">교수 매뉴얼</p>
            <vs-button onclick = "window.open('https://smtp.filledyou.com/student_manual.pdf')" color="success" type="flat" icon-pack="feather" icon="icon-book" style="padding:10px; margin-left:5px;"/><p class="sm:inline-block hidden" style="margin-top:10px;"> 학생 매뉴얼 </p>
            <!-- <vs-button class="lg:inline-block hidden" onclick = "window.open('https://smtp.filledyou.com/professor_manual.pdf')" color="dark" type="flat" icon-pack="feather" icon="icon-book" style="padding:10px; margin-left:20px;"/> -->
        </div>

        <!-- <span class="md:flex hidden items-center">
            <span>Hand-crafted & Made with</span>
            <feather-icon icon="HeartIcon" svgClasses="stroke-current text-danger w-6 h-6" class="ml-2" />
        </span> -->
    </footer>
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        }
    }
}
</script>
